import { memo } from 'react';

interface Props {
  hasSupplierDeal: boolean;
}

export const AnomalyDot = memo(function AnomalyDot({ hasSupplierDeal }: Props) {
  if (!hasSupplierDeal) return null;
  return <span className="ds-dot deal" title="Deal: bestes Lieferantenangebot deutlich unter MEK" />;
});
